import { ChangeDetectionStrategy, Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '@morningstar/shared/base/base-component';
import { merge, Subject } from 'rxjs';
import { exhaustMap, tap } from 'rxjs/operators';
import { Todo } from '../todo';
import { TodoService } from '../todo.service';

@Component({
  selector: 'wsg-edit-todo-dialog',
  templateUrl: './edit-todo-dialog.component.html',
  styleUrls: ['./edit-todo-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditTodoDialogComponent extends BaseComponent implements OnDestroy {

  // == STATE ===================================================

  form = this.formBuilder.group({
    notes: [null, Validators.maxLength(200)],
    pin: [null, Validators.maxLength(40)],
    complete: false
  });

  // == ACTIONS =================================================

  save = new Subject();
  save$ = this.save.asObservable();

  // == SIDE EFFECTS ============================================

  onSave$ = this.save$.pipe(
    exhaustMap(() => this.todoService.addInlineData({
      ...this.todo, 
      ...this.form.value
    }).pipe(
      tap(() => this.dialog.close(true))
    ))
  );

  // == SUBSCRIPTION ============================================

  subscription = merge(
    this.onSave$
  ).subscribe();

  // == LIFECYCLE ===============================================

  constructor(@Inject(MAT_DIALOG_DATA) public todo: Todo,
              private todoService: TodoService,
              private formBuilder: FormBuilder,
              private dialog: MatDialogRef<EditTodoDialogComponent>) {
    super(todoService);

    this.form.patchValue(todo);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
